import { CCMSError } from '../models/common/CCMSError';
/**
 * Maps HTTP status codes to CCMS error codes
 */
export function mapHttpStatusToCode(status) {
    if (status === 400)
        return 'BAD_REQUEST';
    if (status === 401)
        return 'UNAUTHORIZED';
    if (status === 403)
        return 'FORBIDDEN';
    if (status === 404)
        return 'NOT_FOUND';
    if (status === 409)
        return 'CONFLICT';
    if (status === 422)
        return 'VALIDATION_ERROR';
    if (status >= 500)
        return 'SERVER_ERROR';
    return 'UNKNOWN_ERROR';
}
/**
 * Creates a CCMSError from a ResponseData response
 *
 * @param response - The ResponseData response from the API
 * @param httpStatus - The HTTP status code from the response
 * @param correlationId - Optional correlation ID for request tracing
 * @returns A CCMSError instance
 */
export function createCcmsError(response, httpStatus, correlationId) {
    const status = response.statusCode || httpStatus;
    const code = mapHttpStatusToCode(status);
    return new CCMSError({
        code,
        message: response.message || `Request failed with status ${status}`,
        status,
        errors: response.errors || undefined,
        correlationId,
        raw: response
    });
}
//# sourceMappingURL=errorHelpers.js.map